// extracted by mini-css-extract-plugin
export default {"print":"Print_print__D63ep","print__btn":"Print_print__btn__6aDtZ"};